import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

const Todo = ({ text, todo, todos, setTodos, completed, id, index }) => {
  const deleteHandler = () => {
    setTodos(todos.filter((el) => el.id !== todo.id));
  };

  const completeHandler = () => {
    setTodos(
      todos.map((item) => {
        if (item.id === todo.id) {
          return { ...item, completed: !item.completed };
        }
        return item;
      })
    );
  };

  return (
    <Draggable draggableId={String(todo.id)} index={index}>
      {(provided) => {
        return (
          <div
            className={`todo ${todo.completed ? 'completed' : ''}`}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
          >
            <li className="todo-item">{text}</li>
            <button onClick={completeHandler} className="complete-btn">
              <i className="fas fa-check"></i>
            </button>
            <button onClick={deleteHandler} className="trash-btn">
              <i className="fas fa-trash"></i>
            </button>
          </div>
        );
      }}
    </Draggable>
  );
};

export default Todo;
